//#region ../src/types/ar-types.ts
/**
* Extract the raw odometry position tuple from an {@link ARPose}.
*
* Returns the raw WebXR position without coordinate conversion — the reducer
* applies the WebXR→NUE transform when storing into state (raw-storage
* pattern, see gps-plus-slam/GpsPlusSlamJs_Docs/docs/2026-04-09-raw-storage-convert-on-read.md).
* WebXR local-floor frame: X=East, Y=Up, Z=South (toward viewer / backward).
*
* Lives next to the type (quality-review G-8 — it used to sit in
* `state/gps-event-coordinator.ts`, forcing an ar→state import in
* `ar/depth-sampler.ts`).
*/
function extractOdomPosition(arPose) {
	return [
		arPose.position.x,
		arPose.position.y,
		arPose.position.z
	];
}
/** Extract the raw odometry rotation tuple from an {@link ARPose}. */
function extractOdomRotation(arPose) {
	return [
		arPose.orientation.x,
		arPose.orientation.y,
		arPose.orientation.z,
		arPose.orientation.w
	];
}
//#endregion
export { extractOdomPosition, extractOdomRotation };
